import { IMessage } from 'store/slices/messages';

export const getCtaLink = (cta: IMessage['cta']) => {
  let url = cta?.url;
  let target = '_self';

  if (url) {
    url = url.replace('https://', '').replace('http://', '');
    switch (cta?.type) {
      case 'http':
        url = `https://${url}`;
        target = '_blank';
        break;
      case 'mailto':
        url = `mailto:${url}`;
        break;
      case 'tel':
        url = `tel:${url}`;
        break;
      default:
    }
  }

  return { url: url ?? undefined, target };
};
